import { render } from "./ForgetPassword.vue?vue&type=template&id=7c5d8346"
import script from "./ForgetPassword.vue?vue&type=script&lang=js"
export * from "./ForgetPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\PHPStormServer\\s_hmel\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__